import styled from 'styled-components';
import {Button} from '@mui/material';

function FormikSelectField(props) {
    const {
        values,
        name,
        setFieldValue,
        items,
        label,
        description,
        column = false,
        centerLabel = false,
        errors,
        touched
    } = props;

    const activeItem = items.find((item) => item.value == values[name]);

    const isError = touched[name] && errors[name];

    return (
        <Wrapper column={column} centerLabel={centerLabel} isError={isError}>
            <p className="label">{label}</p>
            <div>
                <div className="btn-container">
                    {items.map((item) => (
                        <StyledButton
                            name={name}
                            isError={isError}
                            length={items.length}
                            column={column}
                            key={item.label}
                            isActive={activeItem?.value === item.value}
                            onClick={() => setFieldValue(name, item.value)}
                        >
                            <p style={{width: '100%'}}>{item.label}</p>
                        </StyledButton>
                    ))}
                </div>
                <p className="description">{isError ? errors[name] : description}</p>
            </div>

        </Wrapper>
    );
}

const Wrapper = styled.div`
  width: 100%;
  @media screen and (min-width: 1024px) {
    min-height: 114px;
    display: grid;
    grid-template-columns: 50% 50%;
    place-content: center;

    .label {
      color: #4e4e4e !important;
      margin: auto 0 !important;
      padding: 0 !important;
      font-size: 19px !important;
      font-weight: 400 !important;
    }

    .description {
      font-weight: 400 !important;
      font-size: 16px !important;
      margin-top: 6px !important;
      color: ${({isError}) => (!isError ? '#7b7b7b' : '#D81D5D')};
    }
  }

  .label {
    text-align: ${({centerLabel}) => (centerLabel ? 'center' : 'left')};
    padding-top: ${({centerLabel}) => (centerLabel ? '12px' : '')};
    color: #707070;
    padding-bottom: 16px;
  }

  .btn-container {
    width: 100%;
    display: flex;
    display: ${({column}) => (column ? 'grid' : 'flex')};
    justify-content: ${({column}) => (column ? '' : ' space-between')};
    gap: ${({column}) => (column ? '12px' : '')};

    align-items: center;
  }

  .description {
    color: #7b7b7b;
    font-size: 12px;
    margin-top: 6px;
    color: ${({isError}) => (!isError ? '#7b7b7b' : '#D81D5D')};
  }
`;

const StyledButton = styled(Button)`
  width: ${({column, length}) =>
          column ? '100%' : length > 2 ? '30%' : '48%'};
  height: 48px !important;
  border-radius: 16px !important;
  border: 1px;
  font-size: 14px;
  text-transform: unset !important;
  border: ${({isError}) =>
          isError ? '1px solid #D81D5D !important' : '1px solid #FFFFFF !important'};
  background: ${({isActive}) =>
          isActive ? '#e0dbe7 !important' : '#f5f5f5 !important'};
  box-shadow: ${({isActive}) =>
          isActive
                  ? '2px 2px 10px 0px #6f4d9f80 inset'
                  : '1px 1px 2px 0px #00000029'};

  p {
    width: 100%;
    color: ${({isError, isActive}) =>
            isActive ? '#6f4d9f' : isError ? '#D81D5D' : '#707070'};
  }

  @media screen and (min-width: 1024px) {
    height: 64px !important;
    font-size: 20px !important;
    font-family: ${({isActive}) => (isActive ? 'dana-bold ' : '400')};
    background: ${({isActive}) =>
            isActive ? '#e0dbe7 !important' : '#ffffff !important'};
    :hover {
      background: #e0dbe7 !important;
      box-shadow: 2px 2px 10px 0px #6f4d9f80 inset
    }
  }
`;

export {FormikSelectField};
